require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./clojure.set.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.misc.coll.js");
goog.provide('com.wsscode.misc.coll');
/**
 * Returns a lazy sequence of the elements of coll, removing any elements that
 *   return duplicate values when passed to a function f.
 */

com.wsscode.misc.coll.distinct_by = function com$wsscode$misc$coll$distinct_by(var_args) {
  var G__24981 = arguments.length;

  switch (G__24981) {
    case 1:
      return com.wsscode.misc.coll.distinct_by.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return com.wsscode.misc.coll.distinct_by.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.misc.coll.distinct_by.cljs$core$IFn$_invoke$arity$1 = function (f) {
  return function (rf) {
    var seen = cljs.core.volatile_BANG_(cljs.core.PersistentHashSet.EMPTY);
    return function () {
      var G__25082 = null;

      var G__25082__0 = function G__25082__0() {
        return rf.cljs$core$IFn$_invoke$arity$0 ? rf.cljs$core$IFn$_invoke$arity$0() : rf.call(null);
      };

      var G__25082__1 = function G__25082__1(result) {
        return rf.cljs$core$IFn$_invoke$arity$1 ? rf.cljs$core$IFn$_invoke$arity$1(result) : rf.call(null, result);
      };

      var G__25082__2 = function G__25082__2(result, x) {
        var fx = f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(x) : f.call(null, x);

        if (cljs.core.contains_QMARK_(cljs.core.deref(seen), fx)) {
          return result;
        } else {
          seen.cljs$core$IVolatile$_vreset_BANG_$arity$2(null, cljs.core.conj.cljs$core$IFn$_invoke$arity$2(seen.cljs$core$IDeref$_deref$arity$1(null), fx));
          return rf.cljs$core$IFn$_invoke$arity$2 ? rf.cljs$core$IFn$_invoke$arity$2(result, x) : rf.call(null, result, x);
        }
      };

      G__25082 = function G__25082(result, x) {
        switch (arguments.length) {
          case 0:
            return G__25082__0.call(this);

          case 1:
            return G__25082__1.call(this, result);

          case 2:
            return G__25082__2.call(this, result, x);
        }

        throw new Error('Invalid arity: ' + arguments.length);
      };

      G__25082.cljs$core$IFn$_invoke$arity$0 = G__25082__0;
      G__25082.cljs$core$IFn$_invoke$arity$1 = G__25082__1;
      G__25082.cljs$core$IFn$_invoke$arity$2 = G__25082__2;
      return G__25082;
    }();
  };
};

com.wsscode.misc.coll.distinct_by.cljs$core$IFn$_invoke$arity$2 = function (f, coll) {
  var step = function com$wsscode$misc$coll$step(xs, seen) {
    return new cljs.core.LazySeq(null, function () {
      return function (p__24989, seen__$1) {
        while (true) {
          var vec__24991 = p__24989;
          var x = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24991, 0, null);
          var xs__$1 = vec__24991;
          var temp__5804__auto__ = cljs.core.seq(xs__$1);

          if (temp__5804__auto__) {
            var s = temp__5804__auto__;
            var fx = f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(x) : f.call(null, x);

            if (cljs.core.contains_QMARK_(seen__$1, fx)) {
              var G__25083 = cljs.core.rest(s);
              var G__25084 = seen__$1;
              p__24989 = G__25083;
              seen__$1 = G__25084;
              continue;
            } else {
              return cljs.core.cons(x, com$wsscode$misc$coll$step(cljs.core.rest(s), cljs.core.conj.cljs$core$IFn$_invoke$arity$2(seen__$1, fx)));
            }
          } else {
            return null;
          }

          break;
        }
      }(xs, seen);
    }, null, null);
  };

  return step(coll, cljs.core.PersistentHashSet.EMPTY);
};

com.wsscode.misc.coll.distinct_by.cljs$lang$maxFixedArity = 2;
/**
 * Returns a lazy sequence removing consecutive duplicates in coll when passed to a function f.
 *   Returns a transducer when no collection is provided.
 */

com.wsscode.misc.coll.dedupe_by = function com$wsscode$misc$coll$dedupe_by(var_args) {
  var G__24997 = arguments.length;

  switch (G__24997) {
    case 1:
      return com.wsscode.misc.coll.dedupe_by.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return com.wsscode.misc.coll.dedupe_by.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.misc.coll.dedupe_by.cljs$core$IFn$_invoke$arity$1 = function (f) {
  return function (rf) {
    var pv = cljs.core.volatile_BANG_(new cljs.core.Keyword("com.wsscode.misc.coll", "none", "com.wsscode.misc.coll/none", 1151350699));
    return function () {
      var G__25086 = null;

      var G__25086__0 = function G__25086__0() {
        return rf.cljs$core$IFn$_invoke$arity$0 ? rf.cljs$core$IFn$_invoke$arity$0() : rf.call(null);
      };

      var G__25086__1 = function G__25086__1(result) {
        return rf.cljs$core$IFn$_invoke$arity$1 ? rf.cljs$core$IFn$_invoke$arity$1(result) : rf.call(null, result);
      };

      var G__25086__2 = function G__25086__2(result, x) {
        var prior = cljs.core.deref(pv);
        var fx = f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(x) : f.call(null, x);
        cljs.core.vreset_BANG_(pv, fx);

        if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(prior, fx)) {
          return result;
        } else {
          return rf.cljs$core$IFn$_invoke$arity$2 ? rf.cljs$core$IFn$_invoke$arity$2(result, x) : rf.call(null, result, x);
        }
      };

      G__25086 = function G__25086(result, x) {
        switch (arguments.length) {
          case 0:
            return G__25086__0.call(this);

          case 1:
            return G__25086__1.call(this, result);

          case 2:
            return G__25086__2.call(this, result, x);
        }

        throw new Error('Invalid arity: ' + arguments.length);
      };

      G__25086.cljs$core$IFn$_invoke$arity$0 = G__25086__0;
      G__25086.cljs$core$IFn$_invoke$arity$1 = G__25086__1;
      G__25086.cljs$core$IFn$_invoke$arity$2 = G__25086__2;
      return G__25086;
    }();
  };
};

com.wsscode.misc.coll.dedupe_by.cljs$core$IFn$_invoke$arity$2 = function (f, coll) {
  return cljs.core.sequence.cljs$core$IFn$_invoke$arity$2(com.wsscode.misc.coll.dedupe_by.cljs$core$IFn$_invoke$arity$1(f), coll);
};

com.wsscode.misc.coll.dedupe_by.cljs$lang$maxFixedArity = 2;
/**
 * Like group by, but will keep only the last result.
 */

com.wsscode.misc.coll.index_by = function com$wsscode$misc$coll$index_by(f, coll) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (m, x) {
    return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m, f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(x) : f.call(null, x), x);
  }, cljs.core.PersistentArrayMap.EMPTY, coll);
};
/**
 * Return the first element in coll that returns true for f.
 */


com.wsscode.misc.coll.find_first = function com$wsscode$misc$coll$find_first(f, coll) {
  return cljs.core.first(cljs.core.filter.cljs$core$IFn$_invoke$arity$2(f, coll));
};

com.wsscode.misc.coll.sconj = cljs.core.fnil.cljs$core$IFn$_invoke$arity$2(cljs.core.conj, cljs.core.PersistentHashSet.EMPTY);
com.wsscode.misc.coll.vconj = cljs.core.fnil.cljs$core$IFn$_invoke$arity$2(cljs.core.conj, cljs.core.PersistentVector.EMPTY);
/**
 * Add element to a vector at some specific index. Only works with vectors!
 */

com.wsscode.misc.coll.conj_at_index = function com$wsscode$misc$coll$conj_at_index(v, idx, x) {
  var before = cljs.core.subvec.cljs$core$IFn$_invoke$arity$3(v, 0, idx);
  var after = cljs.core.subvec.cljs$core$IFn$_invoke$arity$3(v, idx, cljs.core.count(v));
  return cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentVector.EMPTY, cljs.core.concat.cljs$core$IFn$_invoke$arity$variadic(before, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [x], null), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([after], 0)));
};
/**
 * Find the index of element x in coll. Return nil if element is not found.
 */


com.wsscode.misc.coll.index_of = function com$wsscode$misc$coll$index_of(coll, x) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (_, p__24999) {
    var vec__25000 = p__24999;
    var i = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__25000, 0, null);
    var x_SINGLEQUOTE_ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__25000, 1, null);

    if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(x, x_SINGLEQUOTE_)) {
      return cljs.core.reduced(i);
    } else {
      return null;
    }
  }, null, cljs.core.map_indexed.cljs$core$IFn$_invoke$arity$2(cljs.core.vector, coll));
};
/**
 * Return a blank immutable queue or create one from coll.
 */


com.wsscode.misc.coll.queue = function com$wsscode$misc$coll$queue(var_args) {
  var G__25007 = arguments.length;

  switch (G__25007) {
    case 0:
      return com.wsscode.misc.coll.queue.cljs$core$IFn$_invoke$arity$0();
      break;

    case 1:
      return com.wsscode.misc.coll.queue.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.misc.coll.queue.cljs$core$IFn$_invoke$arity$0 = function () {
  return cljs.core.PersistentQueue.EMPTY;
};

com.wsscode.misc.coll.queue.cljs$core$IFn$_invoke$arity$1 = function (coll) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$2(com.wsscode.misc.coll.queue.cljs$core$IFn$_invoke$arity$0(), coll);
};

com.wsscode.misc.coll.queue.cljs$lang$maxFixedArity = 1;
/**
 * CLJC helper to create MapEntry.
 */

com.wsscode.misc.coll.make_map_entry = function com$wsscode$misc$coll$make_map_entry(k, v) {
  return new cljs.core.MapEntry(k, v, null);
};
/**
 * Map over the given hash-map keys.
 * 
 *   Example:
 *  (map-keys #(str/replace (name %) "_" "-") {"foo_bar" 1}) => {"foo-bar" 1}
 *   
 */


com.wsscode.misc.coll.map_keys = function com$wsscode$misc$coll$map_keys(f, m) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentArrayMap.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (x) {
    return com.wsscode.misc.coll.make_map_entry(function () {
      var G__25012 = cljs.core.key(x);
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(G__25012) : f.call(null, G__25012);
    }(), cljs.core.val(x));
  }), m);
};
/**
 * Map over the given hash-map vals.
 * 
 *   Example:
 *  (map-vals inc {:a 1 :b 2})
 *   
 */


com.wsscode.misc.coll.map_vals = function com$wsscode$misc$coll$map_vals(f, m) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentArrayMap.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (x) {
    return com.wsscode.misc.coll.make_map_entry(cljs.core.key(x), function () {
      var G__25013 = cljs.core.val(x);
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(G__25013) : f.call(null, G__25013);
    }());
  }), m);
};

com.wsscode.misc.coll.filter_keys = function com$wsscode$misc$coll$filter_keys(f, m) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentArrayMap.EMPTY, cljs.core.filter.cljs$core$IFn$_invoke$arity$1(cljs.core.comp.cljs$core$IFn$_invoke$arity$2(f, cljs.core.key)), m);
};

com.wsscode.misc.coll.filter_vals = function com$wsscode$misc$coll$filter_vals(f, m) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentArrayMap.EMPTY, cljs.core.filter.cljs$core$IFn$_invoke$arity$1(cljs.core.comp.cljs$core$IFn$_invoke$arity$2(f, cljs.core.val)), m);
};

com.wsscode.misc.coll.remove_keys = function com$wsscode$misc$coll$remove_keys(f, m) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentArrayMap.EMPTY, cljs.core.remove.cljs$core$IFn$_invoke$arity$1(cljs.core.comp.cljs$core$IFn$_invoke$arity$2(f, cljs.core.key)), m);
};

com.wsscode.misc.coll.remove_vals = function com$wsscode$misc$coll$remove_vals(f, m) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentArrayMap.EMPTY, cljs.core.remove.cljs$core$IFn$_invoke$arity$1(cljs.core.comp.cljs$core$IFn$_invoke$arity$2(f, cljs.core.val)), m);
};
/**
 * Return the map keys, as a set. This also checks if the entry is a map, otherwise
 *   returns nil (instead of throw).
 */


com.wsscode.misc.coll.keys_set = function com$wsscode$misc$coll$keys_set(m) {
  if (cljs.core.map_QMARK_(m)) {
    return cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentHashSet.EMPTY, cljs.core.keys(m));
  } else {
    return null;
  }
};
/**
 * Additive merging.
 * 
 *   When merging maps, it does a deep merge.
 *   When merging sets, makes a union of them.
 * 
 *   When value of the right side is nil, the left side will be kept.
 * 
 *   For the rest works as standard merge.
 */


com.wsscode.misc.coll.merge_grow = function com$wsscode$misc$coll$merge_grow(var_args) {
  var G__25023 = arguments.length;

  switch (G__25023) {
    case 0:
      return com.wsscode.misc.coll.merge_grow.cljs$core$IFn$_invoke$arity$0();
      break;

    case 1:
      return com.wsscode.misc.coll.merge_grow.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return com.wsscode.misc.coll.merge_grow.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.misc.coll.merge_grow.cljs$core$IFn$_invoke$arity$0 = function () {
  return cljs.core.PersistentArrayMap.EMPTY;
};

com.wsscode.misc.coll.merge_grow.cljs$core$IFn$_invoke$arity$1 = function (a) {
  return a;
};

com.wsscode.misc.coll.merge_grow.cljs$core$IFn$_invoke$arity$2 = function (a, b) {
  if (cljs.core.set_QMARK_(a) && cljs.core.set_QMARK_(b)) {
    return clojure.set.union.cljs$core$IFn$_invoke$arity$2(a, b);
  } else {
    if (cljs.core.map_QMARK_(a) && cljs.core.map_QMARK_(b)) {
      return cljs.core.merge_with.cljs$core$IFn$_invoke$arity$variadic(com.wsscode.misc.coll.merge_grow, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a, b], 0));
    } else {
      if (b == null) {
        return a;
      } else {
        return b;
      }
    }
  }
};

com.wsscode.misc.coll.merge_grow.cljs$lang$maxFixedArity = 2;
/**
 * Like merge, but only add keys that are not present in the original map.
 */

com.wsscode.misc.coll.merge_defaults = function com$wsscode$misc$coll$merge_defaults(m, defaults) {
  return cljs.core.reduce_kv(function (m__$1, k, v) {
    if (cljs.core.contains_QMARK_(m__$1, k)) {
      return m__$1;
    } else {
      return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m__$1, k, v);
    }
  }, m, defaults);
};

com.wsscode.misc.coll._STAR_deep_merge_handlers_STAR_ = cljs.core.PersistentArrayMap.EMPTY;

com.wsscode.misc.coll.value_merger = function com$wsscode$misc$coll$value_merger(x) {
  var G__25024 = x;
  var G__25024__$1 = G__25024 == null ? null : cljs.core.meta(G__25024);

  if (G__25024__$1 == null) {
    return null;
  } else {
    return new cljs.core.Keyword("com.wsscode.misc.coll", "merge-with", "com.wsscode.misc.coll/merge-with", -764343606).cljs$core$IFn$_invoke$arity$1(G__25024__$1);
  }
};
/**
 * Merge util to keep the value from the left side.
 */


com.wsscode.misc.coll.keep_current = function com$wsscode$misc$coll$keep_current(a, _) {
  return a;
};
/**
 * Merge util to keep the value from the right side.
 */


com.wsscode.misc.coll.keep_new = function com$wsscode$misc$coll$keep_new(_, b) {
  return b;
};
/**
 * Recursively merges maps together. If all the maps supplied have nested maps
 *   under the same keys, these nested maps are merged.
 * 
 *   A custom merge strategy may be configured for specific keys, to do so you need to
 *   bind the value of *deep-merge-handlers*, the keys are the keywords and the values
 *   are functions to handle the merge of that key.
 * 
 *    (binding [*deep-merge-handlers* {:foo +}]
 *      (deep-merge {:foo 1} {:foo 2}))
 *    ; => {:foo 3}
 * 
 *   Another way to control the merge of values is to set some metadata to control the
 *   merge process (notice it only applies for types that support meta like maps and vectors,
 *   but not for keywords or numbers for example).
 * 
 *    (deep-merge {:list [1 2 3]} ^{::merge-with into} {:list [:a :b]})
 *    ; => {:list [1 2 3 :a :b]}
 * 
 *   The meta may go in the left or side of the merge, the right side has higher priority.
 * 
 *   Note that meta mergers have higher priority than merge handlers.
 * 
 *   Here is the merger pick order for clarity:
 * 
 *   1. Value merger from meta at new value
 *   2. Value merger from meta at current value
 *   3. Merge key handler
 *   4. Deep merge (in case both values are maps)
 *   5. Keep the new value (as in `clojure.core/merge`)
 * 
 *   Forked from Medley library.
 */


com.wsscode.misc.coll.deep_merge = function com$wsscode$misc$coll$deep_merge(var_args) {
  var G__25029 = arguments.length;

  switch (G__25029) {
    case 0:
      return com.wsscode.misc.coll.deep_merge.cljs$core$IFn$_invoke$arity$0();
      break;

    case 1:
      return com.wsscode.misc.coll.deep_merge.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return com.wsscode.misc.coll.deep_merge.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___25091 = arguments.length;
      var i__4737__auto___25092 = 0;

      while (true) {
        if (i__4737__auto___25092 < len__4736__auto___25091) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___25092]);
          var G__25094 = i__4737__auto___25092 + 1;
          i__4737__auto___25092 = G__25094;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(2), 0, null);
      return com.wsscode.misc.coll.deep_merge.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], argseq__4758__auto__);
  }
};

com.wsscode.misc.coll.deep_merge.cljs$core$IFn$_invoke$arity$0 = function () {
  return null;
};

com.wsscode.misc.coll.deep_merge.cljs$core$IFn$_invoke$arity$1 = function (a) {
  return a;
};

com.wsscode.misc.coll.deep_merge.cljs$core$IFn$_invoke$arity$2 = function (a, b) {
  if (cljs.core.truth_(function () {
    var or__4126__auto__ = a;

    if (cljs.core.truth_(or__4126__auto__)) {
      return or__4126__auto__;
    } else {
      return b;
    }
  }())) {
    var merge_entry = function com$wsscode$misc$coll$merge_entry(m, e) {
      var k = cljs.core.key(e);
      var v_SINGLEQUOTE_ = cljs.core.val(e);

      if (cljs.core.contains_QMARK_(m, k)) {
        var v = cljs.core.get.cljs$core$IFn$_invoke$arity$2(m, k);

        var merger = function () {
          var or__4126__auto__ = com.wsscode.misc.coll.value_merger(v_SINGLEQUOTE_);

          if (cljs.core.truth_(or__4126__auto__)) {
            return or__4126__auto__;
          } else {
            var or__4126__auto____$1 = com.wsscode.misc.coll.value_merger(v);

            if (cljs.core.truth_(or__4126__auto____$1)) {
              return or__4126__auto____$1;
            } else {
              var or__4126__auto____$2 = cljs.core.get.cljs$core$IFn$_invoke$arity$2(com.wsscode.misc.coll._STAR_deep_merge_handlers_STAR_, k);

              if (cljs.core.truth_(or__4126__auto____$2)) {
                return or__4126__auto____$2;
              } else {
                var or__4126__auto____$3 = cljs.core.map_QMARK_(v) && cljs.core.map_QMARK_(v_SINGLEQUOTE_) ? com.wsscode.misc.coll.deep_merge : null;

                if (cljs.core.truth_(or__4126__auto____$3)) {
                  return or__4126__auto____$3;
                } else {
                  return com.wsscode.misc.coll.keep_new;
                }
              }
            }
          }
        }();

        return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m, k, function () {
          var G__25033 = cljs.core.get.cljs$core$IFn$_invoke$arity$2(m, k);
          var G__25034 = v_SINGLEQUOTE_;
          return merger.cljs$core$IFn$_invoke$arity$2 ? merger.cljs$core$IFn$_invoke$arity$2(G__25033, G__25034) : merger.call(null, G__25033, G__25034);
        }());
      } else {
        return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m, k, v_SINGLEQUOTE_);
      }
    };

    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(merge_entry, function () {
      var or__4126__auto__ = a;

      if (cljs.core.truth_(or__4126__auto__)) {
        return or__4126__auto__;
      } else {
        return cljs.core.PersistentArrayMap.EMPTY;
      }
    }(), cljs.core.seq(b));
  } else {
    return null;
  }
};

com.wsscode.misc.coll.deep_merge.cljs$core$IFn$_invoke$arity$variadic = function (a, b, more) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(com.wsscode.misc.coll.deep_merge, function () {
    var or__4126__auto__ = a;

    if (cljs.core.truth_(or__4126__auto__)) {
      return or__4126__auto__;
    } else {
      return cljs.core.PersistentArrayMap.EMPTY;
    }
  }(), cljs.core.cons(b, more));
};
/** @this {Function} */


com.wsscode.misc.coll.deep_merge.cljs$lang$applyTo = function (seq25026) {
  var G__25027 = cljs.core.first(seq25026);
  var seq25026__$1 = cljs.core.next(seq25026);
  var G__25028 = cljs.core.first(seq25026__$1);
  var seq25026__$2 = cljs.core.next(seq25026__$1);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__25027, G__25028, seq25026__$2);
};

com.wsscode.misc.coll.deep_merge.cljs$lang$maxFixedArity = 2;
/**
 * Like assoc, but noop if v is falsy.
 */

com.wsscode.misc.coll.assoc_if = function com$wsscode$misc$coll$assoc_if(var_args) {
  var G__25040 = arguments.length;

  switch (G__25040) {
    case 3:
      return com.wsscode.misc.coll.assoc_if.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___25097 = arguments.length;
      var i__4737__auto___25098 = 0;

      while (true) {
        if (i__4737__auto___25098 < len__4736__auto___25097) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___25098]);
          var G__25099 = i__4737__auto___25098 + 1;
          i__4737__auto___25098 = G__25099;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(3), 0, null);
      return com.wsscode.misc.coll.assoc_if.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], arguments[2], argseq__4758__auto__);
  }
};

com.wsscode.misc.coll.assoc_if.cljs$core$IFn$_invoke$arity$3 = function (m, k, v) {
  if (cljs.core.truth_(v)) {
    return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m, k, v);
  } else {
    return m;
  }
};

com.wsscode.misc.coll.assoc_if.cljs$core$IFn$_invoke$arity$variadic = function (m, k, v, kvs) {
  while (true) {
    var ret = com.wsscode.misc.coll.assoc_if.cljs$core$IFn$_invoke$arity$3(m, k, v);

    if (cljs.core.truth_(kvs)) {
      var G__25100 = ret;
      var G__25101 = cljs.core.first(kvs);
      var G__25102 = cljs.core.second(kvs);
      var G__25103 = cljs.core.nnext(kvs);
      m = G__25100;
      k = G__25101;
      v = G__25102;
      kvs = G__25103;
      continue;
    } else {
      return ret;
    }

    break;
  }
};
/** @this {Function} */


com.wsscode.misc.coll.assoc_if.cljs$lang$applyTo = function (seq25036) {
  var G__25037 = cljs.core.first(seq25036);
  var seq25036__$1 = cljs.core.next(seq25036);
  var G__25038 = cljs.core.first(seq25036__$1);
  var seq25036__$2 = cljs.core.next(seq25036__$1);
  var G__25039 = cljs.core.first(seq25036__$2);
  var seq25036__$3 = cljs.core.next(seq25036__$2);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__25037, G__25038, G__25039, seq25036__$3);
};

com.wsscode.misc.coll.assoc_if.cljs$lang$maxFixedArity = 3;
/**
 * Update some key when that key is present in the map.
 */

com.wsscode.misc.coll.update_contained = function com$wsscode$misc$coll$update_contained(var_args) {
  var G__25050 = arguments.length;

  switch (G__25050) {
    case 3:
      return com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 4:
      return com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    case 5:
      return com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$5(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
      break;

    case 6:
      return com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$6(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___25105 = arguments.length;
      var i__4737__auto___25106 = 0;

      while (true) {
        if (i__4737__auto___25106 < len__4736__auto___25105) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___25106]);
          var G__25107 = i__4737__auto___25106 + 1;
          i__4737__auto___25106 = G__25107;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(6), 0, null);
      return com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], argseq__4758__auto__);
  }
};

com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$3 = function (m, k, f) {
  if (cljs.core.contains_QMARK_(m, k)) {
    return cljs.core.update.cljs$core$IFn$_invoke$arity$3(m, k, f);
  } else {
    return m;
  }
};

com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$4 = function (m, k, f, a1) {
  if (cljs.core.contains_QMARK_(m, k)) {
    return cljs.core.update.cljs$core$IFn$_invoke$arity$4(m, k, f, a1);
  } else {
    return m;
  }
};

com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$5 = function (m, k, f, a1, a2) {
  if (cljs.core.contains_QMARK_(m, k)) {
    return cljs.core.update.cljs$core$IFn$_invoke$arity$5(m, k, f, a1, a2);
  } else {
    return m;
  }
};

com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$6 = function (m, k, f, a1, a2, a3) {
  if (cljs.core.contains_QMARK_(m, k)) {
    return cljs.core.update.cljs$core$IFn$_invoke$arity$6(m, k, f, a1, a2, a3);
  } else {
    return m;
  }
};

com.wsscode.misc.coll.update_contained.cljs$core$IFn$_invoke$arity$variadic = function (m, k, f, a1, a2, a3, args) {
  if (cljs.core.contains_QMARK_(m, k)) {
    return cljs.core.apply.cljs$core$IFn$_invoke$arity$variadic(cljs.core.update, m, k, f, a1, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a2, a3, args], 0));
  } else {
    return m;
  }
};
/** @this {Function} */


com.wsscode.misc.coll.update_contained.cljs$lang$applyTo = function (seq25043) {
  var G__25044 = cljs.core.first(seq25043);
  var seq25043__$1 = cljs.core.next(seq25043);
  var G__25045 = cljs.core.first(seq25043__$1);
  var seq25043__$2 = cljs.core.next(seq25043__$1);
  var G__25046 = cljs.core.first(seq25043__$2);
  var seq25043__$3 = cljs.core.next(seq25043__$2);
  var G__25047 = cljs.core.first(seq25043__$3);
  var seq25043__$4 = cljs.core.next(seq25043__$3);
  var G__25048 = cljs.core.first(seq25043__$4);
  var seq25043__$5 = cljs.core.next(seq25043__$4);
  var G__25049 = cljs.core.first(seq25043__$5);
  var seq25043__$6 = cljs.core.next(seq25043__$5);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__25044, G__25045, G__25046, G__25047, G__25048, G__25049, seq25043__$6);
};

com.wsscode.misc.coll.update_contained.cljs$lang$maxFixedArity = 6;
/**
 * Update some key if that key is present in the map and value is truthy.
 */

com.wsscode.misc.coll.update_if = function com$wsscode$misc$coll$update_if(var_args) {
  var G__25064 = arguments.length;

  switch (G__25064) {
    case 3:
      return com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 4:
      return com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    case 5:
      return com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$5(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
      break;

    case 6:
      return com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$6(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___25109 = arguments.length;
      var i__4737__auto___25110 = 0;

      while (true) {
        if (i__4737__auto___25110 < len__4736__auto___25109) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___25110]);
          var G__25111 = i__4737__auto___25110 + 1;
          i__4737__auto___25110 = G__25111;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(6), 0, null);
      return com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], argseq__4758__auto__);
  }
};

com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$3 = function (m, k, f) {
  if (cljs.core.truth_(cljs.core.get.cljs$core$IFn$_invoke$arity$2(m, k))) {
    return cljs.core.update.cljs$core$IFn$_invoke$arity$3(m, k, f);
  } else {
    return m;
  }
};

com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$4 = function (m, k, f, a1) {
  if (cljs.core.truth_(cljs.core.get.cljs$core$IFn$_invoke$arity$2(m, k))) {
    return cljs.core.update.cljs$core$IFn$_invoke$arity$4(m, k, f, a1);
  } else {
    return m;
  }
};

com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$5 = function (m, k, f, a1, a2) {
  if (cljs.core.truth_(cljs.core.get.cljs$core$IFn$_invoke$arity$2(m, k))) {
    return cljs.core.update.cljs$core$IFn$_invoke$arity$5(m, k, f, a1, a2);
  } else {
    return m;
  }
};

com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$6 = function (m, k, f, a1, a2, a3) {
  if (cljs.core.truth_(cljs.core.get.cljs$core$IFn$_invoke$arity$2(m, k))) {
    return cljs.core.update.cljs$core$IFn$_invoke$arity$6(m, k, f, a1, a2, a3);
  } else {
    return m;
  }
};

com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$variadic = function (m, k, f, a1, a2, a3, args) {
  if (cljs.core.truth_(cljs.core.get.cljs$core$IFn$_invoke$arity$2(m, k))) {
    return cljs.core.apply.cljs$core$IFn$_invoke$arity$variadic(cljs.core.update, m, k, f, a1, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a2, a3, args], 0));
  } else {
    return m;
  }
};
/** @this {Function} */


com.wsscode.misc.coll.update_if.cljs$lang$applyTo = function (seq25057) {
  var G__25058 = cljs.core.first(seq25057);
  var seq25057__$1 = cljs.core.next(seq25057);
  var G__25059 = cljs.core.first(seq25057__$1);
  var seq25057__$2 = cljs.core.next(seq25057__$1);
  var G__25060 = cljs.core.first(seq25057__$2);
  var seq25057__$3 = cljs.core.next(seq25057__$2);
  var G__25061 = cljs.core.first(seq25057__$3);
  var seq25057__$4 = cljs.core.next(seq25057__$3);
  var G__25062 = cljs.core.first(seq25057__$4);
  var seq25057__$5 = cljs.core.next(seq25057__$4);
  var G__25063 = cljs.core.first(seq25057__$5);
  var seq25057__$6 = cljs.core.next(seq25057__$5);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__25058, G__25059, G__25060, G__25061, G__25062, G__25063, seq25057__$6);
};

com.wsscode.misc.coll.update_if.cljs$lang$maxFixedArity = 6;

com.wsscode.misc.coll.native_map_QMARK_ = function com$wsscode$misc$coll$native_map_QMARK_(x) {
  return x instanceof cljs.core.PersistentArrayMap || x instanceof cljs.core.PersistentHashMap;
};
/**
 * Sorts output list to match input list order.
 * 
 *    (coll/restore-order
 *      [{:id 1} {:id 2} {:id 3}]
 *      :id
 *      [{:id 4 :x "a"}
 *       {:id 1 :x "b"}
 *       {:id 3 :x "c"}
 *       {:id 2 :x "d"}])
 * 
 *    => [{:id 1 :x "b"}
 *        {:id 2 :x "d"}
 *        {:id 3 :x "c"}]
 * 
 * Note it will also remove items that don't match anything in the original items
 * list.
 * 
 * In case the items contains a matching key more than once, the last one will be taken.
 */


com.wsscode.misc.coll.restore_order = function com$wsscode$misc$coll$restore_order(var_args) {
  var G__25067 = arguments.length;

  switch (G__25067) {
    case 3:
      return com.wsscode.misc.coll.restore_order.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 4:
      return com.wsscode.misc.coll.restore_order.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.misc.coll.restore_order.cljs$core$IFn$_invoke$arity$3 = function (inputs, key, items) {
  return com.wsscode.misc.coll.restore_order.cljs$core$IFn$_invoke$arity$4(inputs, key, items, function (p1__25065_SHARP_) {
    return cljs.core.PersistentHashMap.fromArrays([key], [cljs.core.get.cljs$core$IFn$_invoke$arity$2(p1__25065_SHARP_, key)]);
  });
};

com.wsscode.misc.coll.restore_order.cljs$core$IFn$_invoke$arity$4 = function (inputs, key, items, default_fn) {
  var index = com.wsscode.misc.coll.index_by(key, items);
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentVector.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (input) {
    var or__4126__auto__ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(index, cljs.core.get.cljs$core$IFn$_invoke$arity$2(input, key));

    if (cljs.core.truth_(or__4126__auto__)) {
      return or__4126__auto__;
    } else {
      return default_fn.cljs$core$IFn$_invoke$arity$1 ? default_fn.cljs$core$IFn$_invoke$arity$1(input) : default_fn.call(null, input);
    }
  }), inputs);
};

com.wsscode.misc.coll.restore_order.cljs$lang$maxFixedArity = 4;
/**
 * Same functionality as restore-order, but fixes the arguments order to make
 *   it easier to thread with a default-fn.
 * 
 *   Also, it returns nil for not found items instead of a map with the key.
 */

com.wsscode.misc.coll.restore_order2 = function com$wsscode$misc$coll$restore_order2(var_args) {
  var G__25070 = arguments.length;

  switch (G__25070) {
    case 3:
      return com.wsscode.misc.coll.restore_order2.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 4:
      return com.wsscode.misc.coll.restore_order2.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.misc.coll.restore_order2.cljs$core$IFn$_invoke$arity$3 = function (inputs, key, items) {
  return com.wsscode.misc.coll.restore_order.cljs$core$IFn$_invoke$arity$4(inputs, key, items, cljs.core.constantly(null));
};

com.wsscode.misc.coll.restore_order2.cljs$core$IFn$_invoke$arity$4 = function (inputs, key, default_fn, items) {
  return com.wsscode.misc.coll.restore_order.cljs$core$IFn$_invoke$arity$4(inputs, key, items, default_fn);
};

com.wsscode.misc.coll.restore_order2.cljs$lang$maxFixedArity = 4;
/**
 * CLJC utility to get an iterator from the collection.
 */

com.wsscode.misc.coll.iterator = function com$wsscode$misc$coll$iterator(coll) {
  return cljs.core.iter(coll);
};
/**
 * Like iterate, but stops when it sees a `nil` value.
 */


com.wsscode.misc.coll.iterate_while = function com$wsscode$misc$coll$iterate_while(f, x) {
  return cljs.core.take_while.cljs$core$IFn$_invoke$arity$2(cljs.core.some_QMARK_, cljs.core.iterate(f, x));
};
/**
 * Return true if column add items at head with conj.
 */


com.wsscode.misc.coll.coll_append_at_head_QMARK_ = function com$wsscode$misc$coll$coll_append_at_head_QMARK_(s) {
  return !(cljs.core.vector_QMARK_(s) || cljs.core.set_QMARK_(s));
};
/**
 * Returns true for sequential collections and sets, false for maps.
 */


com.wsscode.misc.coll.collection_QMARK_ = function com$wsscode$misc$coll$collection_QMARK_(x) {
  return cljs.core.sequential_QMARK_(x) || cljs.core.set_QMARK_(x);
};
/**
 * Compare two vectors, this expects the vectors to be ordered.
 */


com.wsscode.misc.coll.vector_compare = function com$wsscode$misc$coll$vector_compare(p__25072, p__25073) {
  while (true) {
    var vec__25074 = p__25072;
    var seq__25075 = cljs.core.seq(vec__25074);
    var first__25076 = cljs.core.first(seq__25075);
    var seq__25075__$1 = cljs.core.next(seq__25075);
    var value1 = first__25076;
    var rest1 = seq__25075__$1;
    var vec__25077 = p__25073;
    var seq__25078 = cljs.core.seq(vec__25077);
    var first__25079 = cljs.core.first(seq__25078);
    var seq__25078__$1 = cljs.core.next(seq__25078);
    var value2 = first__25079;
    var rest2 = seq__25078__$1;
    var result = cljs.core.compare(value1, value2);

    if (!(result === 0)) {
      return result;
    } else {
      if (value1 == null) {
        return 0;
      } else {
        var G__25116 = rest1;
        var G__25117 = rest2;
        p__25072 = G__25116;
        p__25073 = G__25117;
        continue;
      }
    }

    break;
  }
};

Object.defineProperty(module.exports, "assoc_if", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.assoc_if;
  }
});
Object.defineProperty(module.exports, "index_by", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.index_by;
  }
});
Object.defineProperty(module.exports, "restore_order", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.restore_order;
  }
});
Object.defineProperty(module.exports, "distinct_by", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.distinct_by;
  }
});
Object.defineProperty(module.exports, "update_if", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.update_if;
  }
});
Object.defineProperty(module.exports, "merge_grow", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.merge_grow;
  }
});
Object.defineProperty(module.exports, "find_first", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.find_first;
  }
});
Object.defineProperty(module.exports, "keys_set", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.keys_set;
  }
});
Object.defineProperty(module.exports, "iterate_while", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.iterate_while;
  }
});
Object.defineProperty(module.exports, "filter_vals", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.filter_vals;
  }
});
Object.defineProperty(module.exports, "coll_append_at_head_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.coll_append_at_head_QMARK_;
  }
});
Object.defineProperty(module.exports, "deep_merge", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.deep_merge;
  }
});
Object.defineProperty(module.exports, "keep_current", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.keep_current;
  }
});
Object.defineProperty(module.exports, "queue", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.queue;
  }
});
Object.defineProperty(module.exports, "remove_vals", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.remove_vals;
  }
});
Object.defineProperty(module.exports, "dedupe_by", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.dedupe_by;
  }
});
Object.defineProperty(module.exports, "keep_new", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.keep_new;
  }
});
Object.defineProperty(module.exports, "vconj", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.vconj;
  }
});
Object.defineProperty(module.exports, "collection_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.collection_QMARK_;
  }
});
Object.defineProperty(module.exports, "map_keys", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.map_keys;
  }
});
Object.defineProperty(module.exports, "remove_keys", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.remove_keys;
  }
});
Object.defineProperty(module.exports, "make_map_entry", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.make_map_entry;
  }
});
Object.defineProperty(module.exports, "value_merger", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.value_merger;
  }
});
Object.defineProperty(module.exports, "filter_keys", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.filter_keys;
  }
});
Object.defineProperty(module.exports, "vector_compare", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.vector_compare;
  }
});
Object.defineProperty(module.exports, "update_contained", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.update_contained;
  }
});
Object.defineProperty(module.exports, "native_map_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.native_map_QMARK_;
  }
});
Object.defineProperty(module.exports, "iterator", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.iterator;
  }
});
Object.defineProperty(module.exports, "conj_at_index", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.conj_at_index;
  }
});
Object.defineProperty(module.exports, "_STAR_deep_merge_handlers_STAR_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll._STAR_deep_merge_handlers_STAR_;
  }
});
Object.defineProperty(module.exports, "restore_order2", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.restore_order2;
  }
});
Object.defineProperty(module.exports, "map_vals", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.map_vals;
  }
});
Object.defineProperty(module.exports, "sconj", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.sconj;
  }
});
Object.defineProperty(module.exports, "index_of", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.index_of;
  }
});
Object.defineProperty(module.exports, "merge_defaults", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.coll.merge_defaults;
  }
});